module.exports = __webpack_public_path__ + "img/WechatIMG1965.dbef8a80.jpeg";